import { HomepageDownloadSummary } from "../../../graphql/types";

import { TransferRow } from "./TransferRow";
import { hasAllDaysMissing } from "./utils";

const getDownloadStatus = (download: Omit<HomepageDownloadSummary, "reportDatetimes" | "keys" | "status">) => {
  const isDownloadSuspended = download.artifactStatus === "suspended";
  const isDependencyBlocked = download.dependencyStatus === "suspended" || download.dependencyStatus === "blocked";
  const isDirty = download.event?.severity === "warn" && download.event.qualname === "SomeDirtyRows";
  const allDaysMissing = hasAllDaysMissing(download.sparkline);
  if (isDownloadSuspended) {
    if (allDaysMissing) {
      return {
        msg: "This download is suspended, and has not run for over 7 days.",
        status: "error",
      };
    }
    return {
      msg: download.event?.message || "Download is suspended",
      status: download.event?.severity || "error",
    };
  }
  if (isDependencyBlocked) {
    return {
      msg: "Download is blocked",
      status: "warn",
    };
  }
  if (allDaysMissing) {
    return {
      msg: "This download has not run in over seven days",
      status: "warn",
    };
  }
  if (download.event?.message) {
    return {
      msg: download.event.message,
      status: isDirty ? "dirtyWarn" : download.event.severity,
    };
  }
  return {
    msg: "This download is running without issues.",
    status: "success",
  };
};

type DownloadRowProps = {
  download: Omit<HomepageDownloadSummary, "reportDatetimes" | "keys" | "status">;
  isDark: boolean;
  sparklineFirstDate: string;
  refreshData: () => Promise<void>;
  refreshing: boolean;
};

const DownloadRow = ({ download, isDark, sparklineFirstDate, refreshData, refreshing }: DownloadRowProps) => {
  return (
    <TransferRow
      name={download.name}
      sparkline={download.sparkline}
      isDark={isDark}
      sparklineFirstDate={sparklineFirstDate}
      transferStatus={getDownloadStatus(download)}
      type="download"
      artifactStatus={download.artifactStatus}
      refreshData={refreshData}
      refreshing={refreshing}
    />
  );
};

export { DownloadRow };
